export const contactsConstants = {
    CONTACTS_FETCH: 'CONTACTS_FETCH',
    CONTACTS_SUCCESS: 'CONTACTS_SUCCESS',
    CONTACTS_ERROR: 'CONTACTS_ERROR',
    CONTACT_LOCATIONS_SUCCESS: 'CONTACT_LOCATIONS_SUCCESS',
    SET_CONTACTS: 'SET_CONTACTS',
    RESET_CONTACTS: 'RESET_CONTACTS',
    SEARCHED_CONTACTS_SUCCESS: 'SEARCHED_CONTACTS_SUCCESS',
    SEARCHED_CONTACTS_RESET: 'SEARCHED_CONTACTS_RESET',
    BULK_EDIT_DATA_SUCCESS: 'BULK_EDIT_DATA_SUCCESS',
    SET_CONTACT_LOADING: 'SET_CONTACT_LOADING',
    SET_CONTACT: 'SET_CONTACT',
    SET_CONTACT_DRAWER: 'SET_CONTACT_DRAWER',
    SET_CONTACT_DELETE_MODAL: 'SET_CONTACT_DELETE_MODAL',
    SET_CONTACT_EDIT_MODAL: 'SET_CONTACT_EDIT_MODAL',
    SET_CONTACT_MERGE_MODAL: 'SET_CONTACT_MERGE_MODAL',
    SET_CONTACT_INIT_CONVERSATION_MODAL: 'SET_CONTACT_INIT_CONVERSATION_MODAL',
};

export const CONTACT_ACTIVITY_TYPE = {
    MessageSent: 0,
    SurveyResponded: 1,
    SurveySent: 2,
    SurveyReminderSent: 3,
    ConversationStarted: 4,
    ConversationClosed: 5,
    ConversationReopened: 6,
    ContactCreated: 7,
    ReviewLeft: 8,
    Integration: 9,
    CustomEvent: 10,
    CouponRedeemed: 11,
    FormSubmitted: 12,
    AddedToSegment: 13,
};

export const PAYMENT_COMPLETED_EVENT = 'payment.completed';
export const BOOKING_STARTED_EVENT = 'booking.started';
export const BOOKING_ENDED_EVENT = 'booking.ended';
